import module from 'nominas/nomina/module.js'
import template from './template.html'

export default class NominasCargaserviciosComponent {
  constructor ($dialog, $q, $filter) {
    this.$dialog = $dialog
    this.$q = $q
    this.$filter = $filter
    this.empresas = null
    this.movimientos = null
    this.services = []
    this.completed = false
    this.catalogos = {
      Empresas: undefined,
      Agrupaciones: ['Concepto', 'Empresa', 'Empleado'],
    }
    this.filters = {
      groupBy: this.catalogos.Agrupaciones[0],
      needle: '',
    }
  }

  $onInit () {
    this.catalogos.Empresas = this.empresas.$select()
  }

  processor (table) {
    if (table.headers.indexOf('EMPLEADO') >= 0) {
      let idNominfan = table.headers.indexOf('ID NOMIFAN') >= 0
      let id = idNominfan ? 'ID NOMIFAN' : 'ID CLIENTE'
      let registros = table.data
        .map((item) => {
          // Eliminar los servicios vacíos
          Object.keys(item).forEach((key) => {
            const value = parseFloat(item[key].replace(/[^0-9.]/g, ''))
            if (key.indexOf('SERVICIO ') === 0 && (!Number.isFinite(value) || value < 0)) {
              delete item[key]
            }
          })
          return item
        })
        .filter((item) => {
          // Filtrar los registros sin campo EMPLEADO
          if (typeof item['EMPLEADO'] !== 'string' || item['EMPLEADO'] === '') {
            return false
          }

          // Filtrar registros sin algún campo SERVICIO
          let valid = false
          Object.keys(item).forEach((key) => {
            if (key.indexOf('SERVICIO ') === 0) {
              valid = true
            }
          })
          return valid
        })
      let busqueda = registros
        .map((row) => {
          return [
            row[id] ? (Number(row[id]) ? row[id].pad(5, '0') : row[id]) : '',
            row['EMPLEADO'],
          ]
        })
      let empresas = this.catalogos.Empresas.map((item) => ({ID: item.ID, Descripcion: item.Descripcion}))
      let catalogos = {
        Empresas: this.empresas,
      }

      return this.$dialog.show('nominas.cargaServicios.vincular', {
          search: busqueda,
          companies: empresas,
          selected: [],
          idNomifan: idNominfan,
          catalogos: catalogos,
        })
        .then((data) => {
          console.log('vincular', data)
          const services = []

          Object.keys(data).forEach((index) => {
            const row = data[index]
            const registro = registros[index]

            Object.keys(registro).forEach((key) => {
              if (key.indexOf('SERVICIO ') === 0) {
                const code = key.split(' ')[1]
                const importe = parseFloat(registro[key].replace(/[^0-9.]/g, ''))

                services.push({
                  UID: row.UID,
                  ID_Empresa: row.ID_Empresa,
                  ID_Empleado: row.ID_Empleado,
                  Empresa: row.Empresa,
                  Empleado: row.Empleado,
                  Codigo_Movimiento: code,
                  Concepto: this.movimientos[code].Descripcion,
                  Tipo: this.movimientos[code].Tipo,
                  Tipo_Moneda: this.movimientos[code].Moneda,
                  Naturaleza: this.movimientos[code].Naturaleza,
                  Importe: importe,
                  Notas: registro.NOTAS,
                })
              }
            })
          })
          return services
        })
    } else {
      alert('Es necesario seleccionar una columna como el Kárdex')
      return this.$q.reject()
    }
  }

  importar () {
    let headers = []

    headers.push({id: 'ID CLIENTE', name: 'ID Cliente', agrupacion: 'Identificador'})
    headers.push({id: 'ID NOMIFAN', name: 'ID NomiFan', agrupacion: 'Identificador'})
    headers.push({id: 'EMPLEADO', name: 'Nombre del colaborador', test: testKardex, agrupacion: 'Identificador'})

    this.$filter('orderBy')(this.movimientos.$select(), ['Moneda', 'Descripcion'])
      .forEach((item) => {
        headers.push({
          id: 'SERVICIO ' + item['ID'],
          name: `${item.Naturaleza === 'C' ? 'Cargo' : 'Abono'} ${item['Moneda'] === '1' ? 'MXN' : 'USD'} ${item['ID']} - ${item['Descripcion']}`,
          test: conceptTest,
          agrupacion: item.Naturaleza === 'C' ? 'Cargos' : 'Abonos',
        })
      })

    headers.push({id: 'NOTAS', name: 'Notas', agrupacion: 'Otros'})

    this.$dialog.show('nominas.cargaServicios.importar', {
        headers: headers,
        processor: (table) => (this.processor(table)),
      })
      .then((data) => {
        data.filter((item) => item.Importe > 0).forEach((item) => (this.services.push(item)))
      })
  }

  borrar () {
    this.services.length = 0
  }

  editar (item) {
    if (item.Folio || this.completed) return

    item['Importe'] = Number(prompt('Ingrese el importe.', item['Importe'])) || item['Importe']
  }

  guardar () {
    this.$dialog.show('nominas.cargaServicios.guardar', {services: this.services})
      .then((folios) => {
        folios.forEach((folio, index) => {
          this.services[index].Folio = folio
        })
        this.completed = true
      })
  }
}

const testKardex = (value) => {
  return value !== ''
}

const conceptTest = (value) => {
  return Number.isFinite(parseFloat(value))
}

module.component('nominasCargaservicios', {
  controller: NominasCargaserviciosComponent,
  template,
  bindings: {
    empresas: '<',
    movimientos: '<',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/cargaservicios/components/component.js